import React from "react"
import { IMerchantPreOnboarding, StandardIcon, colors } from "swiipe.portal.shared"
import {
    EMerchantPreOnboardingIconType,
    getMerchantPreOnboardingIcon,
    getMerchantPreOnboardingIconTitle,
} from "../../services/merchantPreOnboardingService"
import "./MerchantPreOnboardingStatusIcons.scss"

interface IMerchantPreOnboardingStatusIcons {
    preOnboarding: IMerchantPreOnboarding
}

const MerchantPreOnboardingStatusIcons = ({ preOnboarding }: IMerchantPreOnboardingStatusIcons) => {
    const addIcon = (type: EMerchantPreOnboardingIconType, isActive: boolean) => (
        <StandardIcon
            className="merchant-pre-onboarding-status-icons__icon"
            svgComponent={getMerchantPreOnboardingIcon(type)}
            title={getMerchantPreOnboardingIconTitle(type)}
            padding={3}
            width={30}
            backgroundType="circle"
            backgroundColor={isActive ? colors.iconActiveBackgroundColor : "transparent"}
            componentForegroundColor={isActive ? colors.iconDarkActiveForegroundColor : colors.iconInactiveForegroundColor}
        />
    )

    return (
        <div className="merchant-pre-onboarding-status-icons">
            {addIcon("created", true)}
            {addIcon("sent", preOnboarding.isSent)}
            {addIcon("password", preOnboarding.isOwnerConfirmed)}
            {addIcon("viewed", preOnboarding.isViewed)}
            {addIcon("signed", preOnboarding.isSigned)}
            {preOnboarding.requiresAcquiring && addIcon("kyc", preOnboarding.isAcquiringOnboarded)}
        </div>
    )
}

export default MerchantPreOnboardingStatusIcons
